/**
 * BaaS home dashboard helpers — alerts are instance-scoped (never hardcoded).
 */

import { fetchBaasApiMetrics } from "../../../../Services/baasApiApi";

export const EMPTY_BAAS_HOME_ALERTS = {
  webhookFailureCount: 0,
  apiErrorCount: 0,
};

/**
 * Map live api-metrics payload → home attention counts for the selected instance.
 * @param {object|null|undefined} metrics
 */
export const mapBaasApiMetricsToHomeAlerts = (metrics) => {
  if (!metrics) return { ...EMPTY_BAAS_HOME_ALERTS };

  const status = metrics.status_breakdown ?? metrics.statusBreakdown ?? {};
  const totals = metrics.totals ?? {};
  const health = metrics.health_summary ?? metrics.healthSummary ?? {};

  const apiErrorCount = Number(
    status.server_error_5xx ??
      status.serverError5xx ??
      totals.server_error_5xx ??
      totals.serverError5xx ??
      0,
  );

  const incidents = Array.isArray(health.incidents) ? health.incidents : [];
  const webhookFailureCount = Number(
    metrics.webhook_failure_count ??
      metrics.webhookFailureCount ??
      incidents.filter((item) =>
        String(item?.title || item?.type || "")
          .toLowerCase()
          .includes("webhook"),
      ).length ??
      0,
  );

  return {
    webhookFailureCount: Number.isFinite(webhookFailureCount)
      ? Math.max(0, webhookFailureCount)
      : 0,
    apiErrorCount: Number.isFinite(apiErrorCount) ? Math.max(0, apiErrorCount) : 0,
  };
};

/**
 * Fetch attention-item counts for the selected BaaS instance (24h by default).
 * @param {object} instance
 * @param {{ period?: string }} [options]
 */
export const fetchBaasHomeAlerts = async (instance, options = {}) => {
  if (!instance) return { ...EMPTY_BAAS_HOME_ALERTS };

  try {
    const metrics = await fetchBaasApiMetrics(instance, {
      period: options.period || "24h",
    });
    return mapBaasApiMetricsToHomeAlerts(metrics);
  } catch {
    return { ...EMPTY_BAAS_HOME_ALERTS };
  }
};

/** @deprecated Use {@link fetchBaasHomeAlerts} — mock constants removed. */
export const getMockBaasHomeAlerts = () => ({ ...EMPTY_BAAS_HOME_ALERTS });
